import { parseAsArrayOf, parseAsInteger, useQueryState } from 'nuqs'

import { type GetAllItemOptions } from '@flecto/api/store'
import { type UNSAFE_any } from '@flecto/types'

export type ProductListFiltersState = {
  filters: {
    q: string
    category_ids: GetAllItemOptions['category_ids']
    sort?: GetAllItemOptions['sort']
    order?: GetAllItemOptions['order']
  }

  setFilter: (
    key: keyof ProductListFiltersState['filters'],
    value: UNSAFE_any
  ) => void
}

export function useProductListFilters(): ProductListFiltersState {
  const [term, setTerm] = useQueryState('q', { shallow: true, defaultValue: '' })
  const [sort, setSort] = useQueryState('sort', { shallow: true, defaultValue: 'created_at' })
  const [order, setOrder] = useQueryState('order', { shallow: true, defaultValue: 'asc' })
  const [categoryIds, setCategoryIds] = useQueryState('category_ids', parseAsArrayOf(parseAsInteger, ';').withOptions({
    shallow: true,
  }))

  const filters = {
    q: term,
    category_ids: categoryIds,
    sort,
    order,
  }

  const setFilter = (
    key: keyof ProductListFiltersState['filters'],
    value: UNSAFE_any
  ) => {
    if (key === 'q') {
      setTerm(value)
    } else if (key === 'category_ids') {
      setCategoryIds(value)
    } else if (key === 'sort') {
      setSort(value)
    } else if (key === 'order') {
      setOrder(value)
    }
  }

  return { filters, setFilter } as unknown as ProductListFiltersState
}
